import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CreditCard, Zap, Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import axios from "axios";
import { API } from "@/lib/api";

export function CreditBalance() {
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    axios.get(`${API}/billing/balance`).then(res => setBalance(res.data)).catch(() => {});
  }, []);

  if (!balance || !balance.authenticated) return null;

  return (
    <div className="flex items-center gap-2" data-testid="credit-balance">
      <Link to="/pricing" className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-zinc-800/80 hover:bg-zinc-700/80 transition-colors border border-zinc-700/50">
        <Zap className="w-3.5 h-3.5 text-violet-400" />
        <span className="text-sm font-medium text-white">{balance.total_credits}</span>
        <span className="text-xs text-zinc-500">credits</span>
        {balance.plan_name && (
          <Badge className="bg-violet-500/15 text-violet-400 border-violet-500/30 text-xs ml-1">{balance.plan_name}</Badge>
        )}
      </Link>
    </div>
  );
}
